module.exports = __webpack_public_path__ + "img/avatar_hipster.d768cde0.svg";